import BaseService from '../base';

class DatastudioReport extends BaseService {}

export default new DatastudioReport('datastudio-reports', 'DatastudioReport');
